// Browser translators (Chrome/Google Translate, Edge) wrap text nodes in <font> tags.
// React then tries to remove/insert nodes that are no longer direct children and crashes
// the whole tree (white page). Fall back gracefully instead of throwing (facebook/react#11538).
if (typeof Node === "function" && Node.prototype) {
  const origRemove = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      if (child.parentNode) return origRemove.call(child.parentNode, child);
      return child;
    }
    return origRemove.call(this, child);
  };
  const origInsert = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, ref) {
    if (ref && ref.parentNode !== this) {
      if (ref.parentNode) return origInsert.call(ref.parentNode, newNode, ref);
      return this.appendChild(newNode);
    }
    return origInsert.call(this, newNode, ref);
  };
}
